(function(){"use strict";var v={"lock-deadbolt":["smart-door-lock-a100-zigbee","smart-door-lock-d100-zigbee","smart-door-lock-d200i"],"lock-rim":["smart-door-lock-u100","smart-door-lock-u100-hub-e1-set-hidden-item","smart-door-lock-u300-matter","smart-door-lock-u400-matter"],"sensor-human":["sensor-motion-sensor-p1","sensor-motion-and-light-sensor-p2-matter","sensor-presence-sensor-fp1e","sensor-presence-sensor-fp2","sensor-presence-multi-sensor-fp300"],"hub-gateway":["hub-m2","hub-m2-poe","hub-m3-matter","hub-e1","hub-m100-matter","hub-m200","hub-smart-wall-hub-v1"],"camera-hub":["camera-hub-g2h-pro","camera-hub-g3","camera-hub-g350","camera-e1","doorbell-g4","doorbell-g410-select","doorbell-g400-select","camera-hub-g5-pro-wifi-poe","camera-g100"],"light-strip":["light-8mm-bare-board-led-light-strip-t2-dual-color","light-cob-led-strip-t1","light-smd-led-light-strip-t1","light-led-strip-t1-rgb"],switch:["smart-switch-smart-magic-switch-s1e","smart-switch-magic-switch-s100-enhanced-edition","smart-switch-magicpad-s1-plus","smart-switch-magicpad-s1-plus-eu","smart-switch-smart-wall-switch-h1-eu-matte-white","smart-switch-smart-wall-switch-h1-eu-gray","smart-wall-switch-h1-champagne-gold-space-gray-h1pro-champagne-gold-space-matte-white","smart-switch-smart-wall-switch-h1-20a","smart-switch-smart-wall-switch-z1-pro","smart-switch-smart-wall-switch-d1-with-neutral"],"light-ceiling":["light-ceiling-light-h1","light-rgb-ceiling-light-t1","light-rgb-ceiling-light-t1m","light-ceiling-light-l1-350","light-smart-sky-mirror-ceiling-light-v1"],"light-spotlight":["light-spotlight-v1","light-spotlight-t2-lite","light-spotlight-t2-pro"],"curtain-track":["windows-curtain-c200","windows-curtain-c4-curtain-controller-set","windows-curtain-curtain-controller-c3","windows-curtain-curtain-controller-motor-cd-m01d-track","windows-curtain-curtain-controller-motor-cd-m01d-extendable-track","windows-curtain-motor-b1-battery-version","windows-curtain-smart-vertical-blinds-controller-h1","windows-curtain-smart-curtain-driver-e1-track-version","windows-curtain-smart-curtain-driver-e1-rod-version"],"curtain-roller":["windows-curtain-roller-shade-controller-t1s","windows-curtain-curtain-rolling-shutter-motor-srsc-m01","windows-curtain-roller-shade-driver-e1"]},O="只能比較同一類型產品",f="[data-compare-add]",w=(function(){var t={};return Object.keys(v).forEach(function(r){v[r].forEach(function(e){t[e]=r})}),t})();function h(t){return t&&Object.prototype.hasOwnProperty.call(w,t)?w[t]:null}function b(t){return h(t)!==null}function C(){return window.CompareMvp.getGroup()}function y(){var t=window.CompareMvp.readStorage(),r=t[C()];return Array.isArray(r)?r.filter(function(e){return e&&e.handle}):[]}function k(){for(var t=y(),r=0;r<t.length;r+=1){var e=t[r]&&t[r].group||h(t[r]&&t[r].handle);if(e)return e}return null}function _(t){var r=t&&t.querySelectorAll?t:document;r.querySelectorAll(f).forEach(function(e){var a=(e.getAttribute("data-compare-handle")||"").trim();b(a)?e.setAttribute("data-cc-allowed",""):e.removeAttribute("data-cc-allowed")})}function x(t){var r=t.target.closest?t.target.closest(f):null;if(r){var e=(r.getAttribute("data-compare-handle")||"").trim();if(!b(e)){t.preventDefault(),t.stopImmediatePropagation();return}var a=y(),i=a.some(function(c){return c.handle===e});if(!i){var o=k(),l=h(e);o&&l&&o!==l&&(t.preventDefault(),t.stopImmediatePropagation(),q(O))}}}function q(t){window.CompareMvp.showToast(t)}function M(){if(!document.getElementById("cc-vsel-css")){var t=document.createElement("style");t.id="cc-vsel-css",t.textContent=".cc-vsel{display:flex;gap:6px;flex-wrap:wrap;}.cc-vsel__pill{cursor:pointer;margin:0;}.cc-vsel__pill input{position:absolute;opacity:0;width:1px;height:1px;}.cc-vsel__pill span{display:inline-block;padding:3px 9px;border:1px solid var(--color--gray,rgba(0,0,0,.25));border-radius:6px;font-size:12px;line-height:1.4;}.cc-vsel__pill input:checked + span{border-color:var(--color--body,#111);font-weight:500;}",document.head.appendChild(t)}}/* CUSTOM:AQARA-HK 2026-08-04 - collections where the per-card variant pills
   (45W 圓形 / 55W 圓形 / 135W 長方形, 8W / 12W ...) are NOT drawn. The compare
   wiring is still applied first, so 規格對比 can switch specs per variant.
   Mirrors NO_VARIANT_PILL_COLLECTIONS in the V12.2 copy of this file. */
var AQ_NO_PILL_COLLECTIONS=["light","light-track-light","light-strip","light-ceiling-light","light-spotlight-downlight","light-led-bulb","all","all-products"];function AQ_NOPILL(){var t=window.location.pathname.split("/").filter(Boolean),r=t[0]==="collections"&&t[1]?t[1]:"";return AQ_NO_PILL_COLLECTIONS.indexOf(r)>-1}
function S(t){var r=t&&t.querySelectorAll?t:document,e=r.querySelectorAll("[data-product-item]");Array.prototype.forEach.call(e,function(a){if(!a.__ccVarDone){var i=a.querySelector("script[data-compare-specs]");if(i){var o;try{o=JSON.parse(i.textContent||"{}")}catch{return}if(!(!o||!o.option_position||!o.variants)){var l=o.option_name||"",c=[];if(Object.keys(o.variants).forEach(function(s){var m=s.indexOf("::")>-1?s.split("::")[1]:s;c.indexOf(m)<0&&c.push(m)}),!(c.length<2)){if(!a.querySelector("script[data-compare-variant-specs]")){var u=document.createElement("script");u.type="application/json",u.setAttribute("data-compare-variant-specs",""),u.textContent=i.textContent,a.appendChild(u)}a.setAttribute("data-swatch-option-position",String(o.option_position)),a.setAttribute("data-swatch-option-name",l);if(AQ_NOPILL()){a.__ccVarDone=!0;return}var P=a.getAttribute("data-handle")||"p"+Math.random().toString(36).slice(2),g='<div class="swatches--container cc-vsel" role="radiogroup">';c.forEach(function(s,m){var E=String(s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/"/g,"&quot;");g+='<label class="cc-vsel__pill"><input class="swatch--input" type="radio" data-item="radio" name="cc-vsel-'+P+'" value="'+E+'"'+(m===0?" checked":"")+"><span>"+E+"</span></label>"}),g+="</div>";var n=a.querySelector(".product-card--swatches--horizontal-view");if(!n){n=document.createElement("div"),n.className="product-card--swatches--horizontal-view";var d=a.querySelector(".cc-card-actions")||a.querySelector(".product-card--details")||a;d.parentNode?d.parentNode.insertBefore(n,d):d.appendChild(n)}n.innerHTML=g,n.style.setProperty("display","block","important");var p=a.querySelector(".product-card--swatches--column-view");p&&p.parentNode&&p.parentNode.removeChild(p),a.__ccVarDone=!0}}}}}),M()}function G(t,r){var e=null;return function(){var a=this,i=arguments;clearTimeout(e),e=setTimeout(function(){t.apply(a,i)},r)}}var T=["[data-body-grid]",'product-recommendations-element[data-intent="related"] [data-container="panel"]',".search--results"];function D(t){window.MutationObserver&&T.forEach(function(r){var e=document.querySelector(r);if(!(!e||e.__ccGridObserved)){e.__ccGridObserved=!0;var a=new MutationObserver(t);a.observe(e,{childList:!0,subtree:!1})}})}function A(){_(document),S(document),document.addEventListener("click",x,!0);var t=G(function(){_(document),S(document)},120);D(t)}document.readyState==="loading"?document.addEventListener("DOMContentLoaded",A):A()})();

/* CUSTOM:AQARA-HK compare-group-footnote — appended block (same in V12.2 / V13.2).
 * Shows a per-family disclaimer at the bottom of the compare sheet.
 * The compare engine wipes [data-cc-table] on every render, so this re-appends
 * idempotently via a MutationObserver. To add a footnote for another family,
 * add an entry with its product handles below. */
(function () {
  'use strict';

  var FOOTNOTES = [
    {
      // 人體 / 動作 / 存在傳感器 (sensor-human group)
      handles: [
        'sensor-motion-sensor-p1',
        'sensor-motion-and-light-sensor-p2-matter',
        'sensor-presence-sensor-fp1e',
        'sensor-presence-sensor-fp2',
        'sensor-presence-multi-sensor-fp300'
      ],
      text: '#感應距離會因安裝位置、環境因素及設定而有所不同'
    }
  ];

  function readItems() {
    try {
      if (window.CompareMvp && typeof window.CompareMvp.readStorage === 'function') {
        var s = window.CompareMvp.readStorage();
        var l = s[window.CompareMvp.getGroup()];
        return Array.isArray(l) ? l : [];
      }
    } catch (e) {}
    try {
      var raw = window.localStorage.getItem('theme1202_compare_mvp_v1');
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      var parts = window.location.pathname.split('/').filter(Boolean);
      var key = (parts[0] === 'collections' && parts[1]) ? 'collection:' + parts[1] : 'global';
      var list = parsed && parsed[key];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function footnoteText() {
    var items = readItems();
    for (var i = 0; i < FOOTNOTES.length; i += 1) {
      for (var j = 0; j < items.length; j += 1) {
        if (items[j] && FOOTNOTES[i].handles.indexOf(items[j].handle) > -1) {
          return FOOTNOTES[i].text;
        }
      }
    }
    return null;
  }

  function ensureCss() {
    if (document.getElementById('cc-footnote-css')) return;
    var st = document.createElement('style');
    st.id = 'cc-footnote-css';
    st.textContent = '.cc-footnote{padding:10px 4px 2px;font-size:12px;line-height:1.5;color:var(--color--gray,#767676);}';
    document.head.appendChild(st);
  }

  function scrubTaglines() {
    // Clean tagline text captured by an older card revision and persisted in
    // localStorage with broken HTML fragments (e.g. "<br", "<span style=...").
    document.querySelectorAll('.cc-product__tagline, .product-card--tagline').forEach(function (el) {
      var t = el.textContent || '';
      var i = t.indexOf('<');
      if (i === -1) return;
      var clean = t.slice(0, i).replace(/\s+$/, '');
      el.textContent = clean;
      if (!clean) el.style.display = 'none';
    });
  }

  // --- self-heal stored items from fresh card data --------------------------
  // The compare engine snapshots specs/tagline into localStorage when a product
  // is added and never re-reads them, so metafield updates don't reach items
  // already in a shopper's selection. On collection pages we re-sync stored
  // items from the freshly rendered cards before the engine initializes.
  function normText(v) {
    if (v == null) return '';
    return String(v).replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
  }

  function normSpecs(rows) {
    if (!Array.isArray(rows)) return [];
    var out = [];
    for (var i = 0; i < rows.length; i += 1) {
      var r = rows[i];
      if (!r || typeof r !== 'object') continue;
      var name = normText(r.name != null ? r.name : (r.label != null ? r.label : r.key));
      if (!name) continue;
      var val = normText(r.title != null ? r.title : (r.value != null ? r.value : (r.val != null ? r.val : (r.text != null ? r.text : r.content))));
      out.push({ section: normText(r.section) || '', name: name, value: val });
    }
    return out;
  }

  function mergeVariantSpecs(item) {
    if (!item.variantSpecs || !item.selectedSwatchValue || !Array.isArray(item.specs)) return;
    var vs = item.variantSpecs;
    var raw = null;
    var nk = item.swatchOptionName ? item.swatchOptionName + '::' + item.selectedSwatchValue : null;
    if (nk && Object.prototype.hasOwnProperty.call(vs, nk) && vs[nk]) {
      raw = vs[nk];
    } else if (Object.prototype.hasOwnProperty.call(vs, item.selectedSwatchValue) && vs[item.selectedSwatchValue]) {
      raw = vs[item.selectedSwatchValue];
    } else {
      for (var k in vs) {
        if (Object.prototype.hasOwnProperty.call(vs, k) && k.indexOf('::') > -1 && k.endsWith('::' + item.selectedSwatchValue)) {
          raw = vs[k];
          break;
        }
      }
    }
    if (!raw) return;
    var v = normSpecs(raw);
    var map = {};
    for (var i = 0; i < v.length; i += 1) map[v[i].name.toLowerCase()] = v[i];
    var merged = [];
    for (var j = 0; j < item.specs.length; j += 1) {
      var key = item.specs[j].name.toLowerCase();
      if (map[key]) {
        merged.push(map[key]);
        delete map[key];
      } else {
        merged.push(item.specs[j]);
      }
    }
    for (var m in map) {
      if (Object.prototype.hasOwnProperty.call(map, m)) merged.push(map[m]);
    }
    item.specs = merged;
  }

  function storageKeyName() {
    try {
      if (window.CompareMvp && window.CompareMvp.STORAGE_KEY) return window.CompareMvp.STORAGE_KEY;
    } catch (e) {}
    return 'theme1202_compare_mvp_v1';
  }

  function groupKey() {
    try {
      if (window.CompareMvp && typeof window.CompareMvp.getGroup === 'function') return window.CompareMvp.getGroup();
    } catch (e) {}
    var parts = window.location.pathname.split('/').filter(Boolean);
    return (parts[0] === 'collections' && parts[1]) ? 'collection:' + parts[1] : 'global';
  }

  function refreshSpecsFromCards() {
    try {
      var keyName = storageKeyName();
      var raw = window.localStorage.getItem(keyName);
      if (!raw) return;
      var storage = JSON.parse(raw);
      if (!storage || typeof storage !== 'object') return;
      var gk = groupKey();
      var items = storage[gk];
      if (!Array.isArray(items) || !items.length) return;
      var changed = false;
      for (var i = 0; i < items.length; i += 1) {
        var item = items[i];
        if (!item || !item.handle) continue;
        var card = document.querySelector('.product-card--root[data-handle="' + item.handle + '"]');
        if (!card) continue;
        var specEl = card.querySelector('script[data-compare-specs]');
        if (!specEl) continue;
        var data;
        try { data = JSON.parse(specEl.textContent || 'null'); } catch (e) { continue; }
        var fresh = null;
        if (Array.isArray(data)) {
          fresh = normSpecs(data);
        } else if (data && typeof data === 'object' && Array.isArray(data.fallback)) {
          fresh = normSpecs(data.fallback);
        }
        if (!fresh || !fresh.length) continue;
        var before = JSON.stringify({ s: item.specs, v: item.variantSpecs, t: item.tagline });
        item.specs = fresh;
        if (data && data.variants) item.variantSpecs = data.variants;
        mergeVariantSpecs(item);
        var btn = card.querySelector('[data-compare-add]');
        if (btn) item.tagline = normText(btn.getAttribute('data-compare-tagline'));
        if (JSON.stringify({ s: item.specs, v: item.variantSpecs, t: item.tagline }) !== before) changed = true;
      }
      if (changed) window.localStorage.setItem(keyName, JSON.stringify(storage));
    } catch (e) {}
  }

  function sync() {
    scrubTaglines();
    var container = document.querySelector('[data-cc-table]');
    if (!container) return;
    var table = container.querySelector('.cc-table');
    var note = container.querySelector('.cc-footnote');
    var text = footnoteText();

    if (!table || !text) {
      if (note) note.remove();
      return;
    }
    if (note && note.textContent === text) return; // idempotent — safe with observers
    if (!note) {
      note = document.createElement('div');
      note.className = 'cc-footnote';
      container.appendChild(note);
    }
    ensureCss();
    note.textContent = text;
  }

  function boot() {
    refreshSpecsFromCards();
    sync();
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i += 1) {
          if (muts[i].addedNodes && muts[i].addedNodes.length) { sync(); break; }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    // Refresh as soon as product cards appear during parsing - this still runs
    // before DOMContentLoaded, so the compare engine's init() reads the
    // refreshed storage rather than a stale snapshot.
    if (window.MutationObserver) {
      var early = new MutationObserver(function () {
        if (document.querySelector('.product-card--root')) refreshSpecsFromCards();
      });
      early.observe(document.documentElement, { childList: true, subtree: true });
      document.addEventListener('DOMContentLoaded', function () { early.disconnect(); });
    }
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
